import React, { useEffect, useState } from "react";
import Container from "../../../components/Container";
import { BtnPadrao, BtnDeletar, BtnEdit, ModalPadrao, LabelPadrao, InputPadrao, CheckBoxPadrao, LoadingContainerPadrao, BtnIncluir } from "../../../components/Base";
import { Divider } from "antd";
import TabelaPadrao from "../../../components/TabelaPadrao";
import * as api from "./api";
import { useFetch, useSave } from "../../../components/Hooks/Conexao";
import Mensagens from "../../../components/Mensagens";
import { connect } from "react-redux";
import { logIn, fetch } from "../../../actions/index";

function Grupo(props) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [detalhe, setDetalhe] = useState(null);

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
    },
    {
      Header: " ",
      accessor: "idGrupo",
      tipo: "right",
      Cell: data => {
        const row = data.row.original.idGrupo;
        return (
          <div>
            <BtnEdit style={{ marginRight: 10 }} onClick={() => setDetalhe(row)} />
            <BtnDeletar
              onOk={() =>
                listarDados(
                  () => api.deletar(props.fetch, row),
                  () => {
                    const aux = [...dados];
                    aux.splice(dados.findIndex(x => x.idGrupo === row), 1);
                    setDados(aux);
                    Mensagens.showSucesso("Grupo deletado com sucesso!");
                  }
                )
              }
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    listarDados(() => api.getAll(props.fetch));
  }, []);

  function onOk(v) {
    const aux = [...dados];

    const regInx = aux.findIndex(x => x.idGrupo === v.idGrupo);

    if (aux.findIndex(x => x.idGrupo === v.idGrupo) !== -1) {
      aux[regInx] = v;
    } else {
      aux.push(v);
    }
    setDados(aux);
    setDetalhe(null);
  }

  return (
    <>
      <Container loading={loading}>
        <div>
          <Divider orientation="left">Grupo</Divider>
          <BtnIncluir type="primary" onClick={() => setDetalhe(-1)} ghost />
        </div>
        <TabelaPadrao columns={columns} data={dados} style={{ margin: "25px 0" }} />
      </Container>
      <ModalInserir fetch={props.fetch} onCancel={() => setDetalhe(null)} onOk={onOk} id={detalhe} />
    </>
  );
}
export default connect(null, { logIn, fetch })(Grupo);

function ModalInserir({ id, onOk, onCancel, fetch, ...props }) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [save, saving] = useSave(
    () => api.post(fetch, dados),
    v => {
      if (v) onOk({ ...dados, idGrupo: v });
      else onOk(dados);
      Mensagens.showSucesso("Dados salvos com sucesso!");
    }
  );

  function onSave() {
    if (!dados.nome) {
      Mensagens.showErro("Dados não preenchidos!");
      return;
    }
    save();
  }

  useEffect(() => {
    if (id) listarDados(() => api.getDetalhe(fetch, id));
  }, [id]);

  return (
    <ModalPadrao
      visible={id}
      onCancel={onCancel}
      title="Grupo"
      footer={
        <>
          <BtnPadrao type="primary" onClick={onSave} loading={saving}>
            Gravar
          </BtnPadrao>
          <BtnPadrao type="primary" onClick={onCancel} ghost>
            Sair
          </BtnPadrao>
        </>
      }
    >
      <LoadingContainerPadrao loading={loading}>
        <div>
          <LabelPadrao noMargin>Nome</LabelPadrao>
          <InputPadrao value={(dados || []).nome} onChange={v => setDados({ ...dados, nome: v.target.value })} autoFocus />
          <LabelPadrao>Variações</LabelPadrao>
          <InputPadrao value={(dados || []).variacoes} placeholder="ex: Grupo 01,Grupo 02..." onChange={v => setDados({ ...dados, variacoes: v.target.value })} />
          <LabelPadrao>Exceçoes</LabelPadrao>
          <InputPadrao value={(dados || []).excecoes} placeholder="ex: Grupo 01,Grupo 02..." onChange={v => setDados({ ...dados, excecoes: v.target.value })} />
        </div>
      </LoadingContainerPadrao>

      {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
    </ModalPadrao>
  );
}
